var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSymbolActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 49,
    viewBox: "0 0 54 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9538 5.28241H6.33301V37.7436H41.9538V5.28241Z",
    fill: "#21187F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8711 40.9926V3.42407",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52441 40.2971V2.72864",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75774 0.5H1.26904V2.9887H3.75774V0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68848 1.75848H44.6158",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1044 0.5H44.6157V2.9887H47.1044V0.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73625 39.7569H1.24756V42.2456H3.73625V39.7569Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64502 40.9924H44.5723",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.061 39.757H44.5723V42.2457H47.061V39.757Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.01 48.5002C48.8385 48.5002 52.7529 44.5859 52.7529 39.7574C52.7529 34.9288 48.8385 31.0145 44.01 31.0145C39.1814 31.0145 35.2671 34.9288 35.2671 39.7574C35.2671 44.5859 39.1814 48.5002 44.01 48.5002Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8149 35.6473L44.0963 44.282",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6816 39.9937L48.3163 39.7124",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9148 10.2226C26.8655 10.2219 26.816 10.2215 26.7664 10.2215C21.3974 10.2215 17.0449 14.574 17.0449 19.943C17.0449 25.3121 21.3974 29.6645 26.7664 29.6645C28.4762 29.6645 30.0829 29.2231 31.4788 28.4481C26.1782 28.3688 21.9057 24.0472 21.9057 18.7277C21.9057 15.0684 23.9274 11.8814 26.9148 10.2226Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSymbolActive);
export default __webpack_public_path__ + "static/media/addSymbolActive.3ae76b05b5b1c78099515b125c6dc5e6.svg";
export { ForwardRef as ReactComponent };